module.exports = __webpack_public_path__ + "img/Rebecca Moonsammy.2f21736c.png";